import Box from '@sendsprint/ui-react/dist/components/Box';
import Container from '@src/components/container';
import React, { lazy, ReactNode } from 'react';
import { ReactComponent as Logo } from '@sendsprint/design-system/brand/logos/logo-full-green.svg';
import { useAccount } from '@src/contexts';
import Dropdown from './dropdown';
import cs from 'classnames';
import { LoggedInClient } from '../..';
import useMedia from '@src/hooks/utils/useMedia';
import SuspenseWrapper from '@src/components/suspenseWrapper';
import Text from '@sendsprint/ui-react/dist/components/Text';
import { truncateString } from '../../utils/truncateString';
// import SwitchEnvironment from './switchEnvironment';

const MobileNavbar = lazy(
  () => import(/*webpackChunkName: 'DashboardMobileNavbar'*/ './mobileNavbar')
);

export interface HeaderProps {
  headerContent?: ReactNode;
  client?: LoggedInClient;
}

const Header = ({ headerContent, client }: HeaderProps) => {
  const { logout, user, logoutLoading, business } = useAccount();
  const { isMobile, isTablet } = useMedia();
  // const { WEBSITE_URL } = useEnv();

  return (
    <Box className="ss-sticky ss-z-10 ss-top-0">
      <Container
        style={{
          backgroundColor: '#F6F8FA'
        }}
        className={cs('')}>
        <Box className="ss-flex ss-justify-between ss-items-center md:ss-px-6 ss-py-3 md:ss-bg-white">
          <Box className="ss-flex ss-items-center ss-gap-2">
            {(isMobile || isTablet) && (
              <SuspenseWrapper returnNullErrorFallback>
                <MobileNavbar client={client} />
              </SuspenseWrapper>
            )}
            <Logo
              className="ss-h-10 ss-w-26 md:ss-w-30 lg:ss-w-56 md:ss-h-10 ss-hidden md:ss-block lg:ss-hidden"
              role="presentation"
            />
            <Box className="ss-hidden lg:ss-block">
              <Text variant="h5">{truncateString(business?.businessName || '')}</Text>
              <Text>Merchant ID: {business?.merchantId}</Text>
              <Text>Get started ⚡️</Text>
            </Box>
            {/* <a target="_blank" rel="noreferrer" href={WEBSITE_URL}>
              <Logo
                className="ss-h-10 ss-w-32 md:ss-w-40 lg:ss-w-56 md:ss-h-10 ss-hidden md:ss-block"
                role="presentation"
              />
            </a> */}
          </Box>
          <Box className="ss-flex ss-items-center ss-gap-5">
            <Box className="ss-block md:ss-hidden">{headerContent}</Box>
            {/* <SwitchEnvironment /> */}
            <Dropdown
              user={user}
              logoutLoading={logoutLoading}
              logoutHandler={logout}
              client={client}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Header;
